import { useState, useEffect, useRef } from 'react';
import Select, { components } from 'react-select';

// Images
import ArrowDownIcon from "images/arrow-down.svg";
import { Icon } from '@iconify/react';

const selectStyles = {
    control: (provided) => ({
        ...provided,
        cursor: "pointer",
        backgroundColor: "white",
        color: "black",
        border: "1px solid #E5E7EB",
        outline: "none",
        borderRadius: "100px",
        minHeight: 30,
        height: 30,
        padding: "0 16px",
        boxShadow: "none",

        ":hover": {
            border: "1px solid #9CA3AF",
            outline: "none",
            backgroundColor: "#f5f5f5",
        },

        ":focus": {
            border: "1px solid #9CA3AF",
            outline: "none",
        },

        ":active": {
            border: "1px solid #9CA3AF",
            outline: "none",
        },

    }),
    menu: (provided) => ({
        ...provided,
        color: "black",
        borderRadius: 10,
        overflow: "hidden",
        boxShadow: "0px 0px 4px 0px #7357EB40",
        backgroundColor: "white",
    }),
    option: (baseStyles) => ({
        ...baseStyles,
        backgroundColor: "white",
        color: "black",
        textAlign: "left",
        cursor: "pointer",
        fontSize: "0.875rem",
        // fontWeight: "500",
        ":hover": {
            backgroundColor: "#f5f5f5",
        }
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        color: "black",
        fontSize: "0.875rem",
        padding: 0,
    }),
    input: (baseStyles) => ({
        ...baseStyles,
        color: "black",
        padding: 0,
    }),
    valueContainer: (baseStyles) => ({
        ...baseStyles,
        padding: 0,
    }),
    indicatorsContainer: (baseStyles) => ({
        ...baseStyles,
        padding: 0,
    }),
    dropdownIndicator: (baseStyles) => ({
        ...baseStyles,
        padding: 0,
    }),
};

const Control = ({ children, ...props }) => (
    <components.Control {...props}>
        {children}
    </components.Control>
);

const normalizeDefaultValue = (value) => {
    if (value && typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, 'value')) return value.value;
    }
    return value;
};

const SelectFilter = ({ options = [], onChange, label, defaultValue }) => {

    const [selectedOption, setSelectedOption] = useState(null);
    const appliedDefaultRef = useRef(null);

    useEffect(() => {
        const normalizedDefault = normalizeDefaultValue(defaultValue);
        if (normalizedDefault == null) return;

        if (appliedDefaultRef.current === normalizedDefault) return;

        const match = options.find(opt => opt?.value === normalizedDefault) || (typeof defaultValue === 'object' ? defaultValue : null);
        if (!match || match.value == null) return;

        appliedDefaultRef.current = normalizedDefault;
        setSelectedOption(match);
        if (typeof onChange === "function") {
            onChange(match);
        }
    }, [defaultValue, options]);

    const onOptionSelect = (selectedData) => {
        setSelectedOption(selectedData);
        if (typeof onChange === "function") {
            onChange(selectedData);
        }
    }

    const onOptionClear = (e) => {
        e.stopPropagation();
        e.preventDefault();

        setSelectedOption(null);
        if (typeof onChange === "function") {
            onChange(null);
        }
        return false;
    }

    return (
        <Select
            label={label}
            placeholder={`Select ${label}`}
            options={options}
            value={selectedOption}
            onChange={onOptionSelect}
            backspaceRemovesValue={false}
            components={{
                Control,
                DropdownIndicator: () => <img src={ArrowDownIcon} style={{ width: 20, height: 20 }} alt="" />,
                IndicatorSeparator: null,
                ClearIndicator: () => <Icon onClick={onOptionClear} icon="mdi:close" style={{ width: 20, height: 20 }} />,
            }}
            isClearable={!true}
            isSearchable={false}
            hideSelectedOptions={false}
            styles={selectStyles}
            tabSelectsValue={false}
        />
    )
}

export default SelectFilter;